/**
 * 🗻 Accounts with emails that should view the app in view-only mode
 */
export const VIEW_ONLY_ACCOUNTS = [
  "onebutton.tester+demo@gmail.com",
]
